<template>
  <figure>
    <picture>
      <source media="(max-width: 799px)" :srcset="require('@/assets/img/einzelrenderings/'+content.picture.thumb)"/>
      <source media="(min-width: 800px)" :srcset="require('@/assets/img/einzelrenderings/wide/'+content.picture.thumbWide)"/>
      <img :src="require('@/assets/img/einzelrenderings/wide/'+content.picture.thumbWide)" alt=""/>
    </picture>
    <figcaption>
      <h3>{{content.title}} - {{content.subtitle}}</h3>
      <div class="showonhover">
        <p>{{ content.excerpt }}</p>
        <a @click="openPopup" class="button" href="#"><span>{{$t('general.moreInformation')}}</span></a>
      </div>
    </figcaption>
  </figure>
</template>
<script>
import {gsap} from "gsap";

export default {
  props: {
    content: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popup: null,
    }
  },
  watch: {
    // Beobachte die `isVisible` Eigenschaft
    isVisible(newValue) {
      // Überprüfe, ob `newValue` true ist
      if (newValue) {
        this.popupBecameVisible();
      }
    }
  },
  methods: {
    openPopup() {
      this.$emit('openPopup',this.content.id);
    },
    popupBecameVisible() {
      this.$nextTick(() => {
        // Standardanimation als Fallback
        let animation = () => {
          this.$refs.popup.style.display = 'block';
          gsap.to(this.$refs.popup, {
            opacity: 1
          });
          gsap.fromTo('.popup_content.popup_content_left', {
            y: "300%",

          }, {
            y: "0%",
            delay: 0.25
          })
          gsap.fromTo('.popup_content_right', {
            x: "300%",
          }, {
            x: "0%",
            delay: 0.75
          })
        };

        if (this.animationType === 'previous') {
          // Definiere eine spezielle Animation für 'previous'
          animation = () => {
            this.$refs.popup.style.display = 'block';
            gsap.fromTo(this.$refs.popup, {
              opacity: 0,
              display: "none",
              x: "100vw"
            }, {
              opacity: 1,
              display: "block",
              x: 0
            })
            gsap.fromTo('.popup_content.popup_content_left', {
              y: "300%",

            }, {
              y: "0%",
              delay: 0.25
            })
            gsap.fromTo('.popup_content_right', {
              x: "300%",
            }, {
              x: "0%",
              delay: 0.75
            })
          };
        } else if (this.animationType === 'next') {
          // Definiere eine spezielle Animation für 'next'
          animation = () => {
            this.$refs.popup.style.display = 'block';
            gsap.fromTo(this.$refs.popup, {
              opacity: 0,
              display: "none",
              x: "-100vw"
            }, {
              opacity: 1,
              display: "block",
              x: 0
            })
            gsap.fromTo('.popup_content.popup_content_left', {
              y: "300%",

            }, {
              y: "0%",
              delay: 0.25
            })
            gsap.fromTo('.popup_content_right', {
              x: "300%",
            }, {
              x: "0%",
              delay: 0.75
            })
          };
        }

        // Führe die ausgewählte Animation aus
        animation();
        // Entscheide basierend auf dem animationType-Prop, welche Animation ausgeführt werden soll

      });
    },
    closePopup() {
      gsap.to(this.$refs.popup, {
        opacity: 0,
        onComplete: () => {
          this.$emit('close');
        }
      });
    },
    previousPopup() {
      this.$emit('previousPopup');
    },
    nextPopup() {
      this.$emit('nextPopup');
    }
  }
}
</script>
<style scoped lang="scss">
  @import 'src/assets/css/components/threeheader';
  h3 {
    font-weight: 400;
    font-size:20px;
  }
</style>
